import { ReactNode, useMemo } from 'react';
import { ButtonTabs } from '~/components/button-tabs/button-tabs';
import { SelectionCard } from '~/components/selection-card-new/selection-card';
import { RenderHtml } from '~/components/text';
import { SelectionCardItem } from '~/graphql/types';

interface FilteredInteriorPackagesProps {
	items: Array<SelectionCardItem & { description?: ReactNode }>;
	tabs: { value: string; label: string }[];
	selectedTab: string;
	setSelectedTab: (seatType: string) => void;
}

export const FilteredInteriorPackages = ({
	items,
	tabs,
	selectedTab,
	setSelectedTab,
}: FilteredInteriorPackagesProps) => {
	const filteredItems = useMemo(
		() => (tabs.length > 1 ? items.filter((item) => item.familyName === selectedTab) : items),
		[tabs.length, items, selectedTab],
	);

	return (
		<>
			{<ButtonTabs setSelectedTab={setSelectedTab} selectedTab={selectedTab} tabs={tabs} />}
			<div>
				{filteredItems.map((item) => (
					<SelectionCard id={item.key} key={item.name} item={item}>
						{item.description && <RenderHtml html={item.description} />}
					</SelectionCard>
				))}
			</div>
		</>
	);
};
